import styles from './styles.module.css';
import error from '../../assets/svgs/errorWhite.svg';
import { useTranslation } from 'react-i18next';

export function LabelNotFoundState() {
    const { t } = useTranslation();

    return (
        <div className={styles.errorContainer}>
            <img className={styles.errorImage} alt="Error logo" src={error} />
            <div className={styles.errorTitle}>{t("noLabelState.contentTitle")}</div>
            <div className={styles.errorSubtitle}>{t("noLabelState.contentSubtitle")}</div>
        </div>
    )
}